const lngs = {
  en: { nativeName: "English", isRtl: false },
  fr: { nativeName: "Français", isRtl: false },
  es: { nativeName: "Español", isRtl: false },
  ar: { nativeName: "عربي", isRtl: true },
  zh: { nativeName: "中文", isRtl: false },
  hi: { nativeName: "हिन्दी", isRtl: false },
  ru: { nativeName: "Русский", isRtl: false },
  pt: { nativeName: "Português", isRtl: false },
  bn: { nativeName: "বাংলা", isRtl: false },
  de: { nativeName: "Deutsch", isRtl: false },
  ja: { nativeName: "日本語", isRtl: false },
  ms: { nativeName: "Bahasa Melayu", isRtl: false },
  ko: { nativeName: "한국어", isRtl: false },
  it: { nativeName: "Italiano", isRtl: false },
  tr: { nativeName: "Türkçe", isRtl: false },
  pl: { nativeName: "Polski", isRtl: false },
  nl: { nativeName: "Nederlands", isRtl: false },
  vi: { nativeName: "Tiếng Việt", isRtl: false },
  th: { nativeName: "ไทย", isRtl: false },
  sv: { nativeName: "Svenska", isRtl: false },
  fa: { nativeName: "فارسی", isRtl: true },
  ur: { nativeName: "اردو", isRtl: true },
  he: { nativeName: "עברית", isRtl: true },
};

export default lngs;
